import React from 'react';
import { Link } from 'react-router-dom';

function formatPrice(p) {
  const n = Number(p);
  if (Number.isNaN(n)) return '';
  return `$${n.toFixed(2).replace(/\.00$/, '')}`;
}

function buildMeta(specialty) {
  const price = formatPrice(specialty.price);
  if (specialty.durationMinutes && price) return `${specialty.durationMinutes} min · ${price}`;
  if (price) return price;
  if (specialty.durationMinutes) return `${specialty.durationMinutes} min`;
  return '';
}

export default function SpecialtyCard({ specialty }) {
  const initial = (specialty.name || '?').charAt(0).toUpperCase();
  const meta = buildMeta(specialty);
  return (
    <Link to={`/specialties/${specialty.slug}`} className="specialty-card">
      {specialty.image ? (
        <img className="specialty-card-image" src={specialty.image} alt={specialty.name} />
      ) : (
        <div className="specialty-card-fallback" aria-hidden="true">{initial}</div>
      )}
      <div className="specialty-card-body">
        <h2 className="specialty-card-name">{specialty.name}</h2>
        {specialty.description && <p className="specialty-card-desc">{specialty.description}</p>}
        {meta && <p className="specialty-card-meta">{meta}</p>}
      </div>
    </Link>
  );
}
